import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const spin = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

export const ButtonSpinner = styled.span`
    width: 10px;
    height: 10px;
    border: 2px solid rgba(0, 0, 0, 0.25);
    border-top-color: #000;
    border-radius: 50%;
    animation: ${spin} 0.7s linear infinite;
`;

export const StyledActionBtn = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    height: 20px;
    width: 20px;
    background: #fcd21d;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    outline: none;

    &:hover {
        opacity: 0.8;
    }

    &:disabled {
    }

    &.loading {
        cursor: wait;
    }
`;
